var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import React, { forwardRef } from 'react';
import { always } from 'ramda';
import classnames from 'classnames';
import NxLoadWrapper from '../NxLoadWrapper/NxLoadWrapper';
import NxLoadError from '../NxLoadError/NxLoadError';
import NxButton from '../NxButton/NxButton';
import NxSubmitMask from '../NxSubmitMask/NxSubmitMask';
import { propTypes } from './types';
import { getFirstValidationError, hasValidationErrors } from '../../util/validationUtil';
var NxForm = forwardRef(function NxForm(props, ref) {
    var className = props.className, loading = props.loading, doLoad = props.doLoad, onSubmitProp = props.onSubmit, onCancel = props.onCancel, loadError = props.loadError, submitError = props.submitError, submitErrorTitleMessage = props.submitErrorTitleMessage, validationErrors = props.validationErrors, submitBtnClassesProp = props.submitBtnClasses, submitBtnText = props.submitBtnText, submitMaskState = props.submitMaskState, submitMaskMessage = props.submitMaskMessage, submitMaskSuccessMessage = props.submitMaskSuccessMessage, children = props.children, additionalFooterBtns = props.additionalFooterBtns, formAttrs = __rest(props, ["className", "loading", "doLoad", "onSubmit", "onCancel", "loadError", "submitError", "submitErrorTitleMessage", "validationErrors", "submitBtnClasses", "submitBtnText", "submitMaskState", "submitMaskMessage", "submitMaskSuccessMessage", "children", "additionalFooterBtns"]), formClasses = classnames('nx-form', className), getChildren = children instanceof Function ? children : always(children), submitDisabled = hasValidationErrors(validationErrors), submitBtnClasses = classnames('nx-form__submit-btn', submitBtnClassesProp, {
        disabled: submitDisabled
    });
    function onSubmit(evt) {
        evt.preventDefault();
        if (!submitDisabled) {
            onSubmitProp();
        }
    }
    var renderForm = function () {
        var submitValidationError = getFirstValidationError(validationErrors) || '', submitAriaLabel = submitValidationError ? "Submit disabled: " + submitValidationError : undefined;
        return (React.createElement("form", __assign({ ref: ref, className: formClasses, onSubmit: onSubmit }, formAttrs),
            getChildren(),
            React.createElement("footer", { className: "nx-footer" },
                submitError &&
                    React.createElement(NxLoadError, { titleMessage: submitErrorTitleMessage || 'An error occurred saving data.', error: submitError, retryHandler: onSubmitProp }),
                React.createElement("div", { className: "nx-btn-bar" },
                    additionalFooterBtns,
                    onCancel &&
                        React.createElement(NxButton, { type: "button", onClick: onCancel, className: "nx-form__cancel-btn" }, "Cancel"),
                    !submitError &&
                        React.createElement(NxButton, { variant: "primary", className: submitBtnClasses || 'nx-form__submit-btn', title: submitValidationError, "aria-label": submitAriaLabel }, submitBtnText || 'Submit'))),
            submitMaskState != null &&
                React.createElement(NxSubmitMask, { success: submitMaskState, message: submitMaskMessage, successMessage: submitMaskSuccessMessage })));
    };
    return doLoad ? (React.createElement(NxLoadWrapper, { loading: loading, error: loadError, retryHandler: doLoad }, renderForm)) : renderForm();
});
NxForm.propTypes = propTypes;
export default NxForm;
export { propTypes };
//# sourceMappingURL=NxForm.js.map